import React, { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../../../context/AuthProvider';

import './Login.css';


const Login = () => {
  const navigate = useNavigate();
  const { onLogin, onRegister } = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');

    const error = await onLogin(email, password);
    if (error) {
      setErrorMessage(error.detail || error.message);
    } else {
      navigate('/');
    }
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    
    try {
      const error = await onRegister(email, password, firstName, lastName)
      if (error) {
      setErrorMessage(error.detail || error.message);
      } else {
        alert('Registration successful! Please login.');
        setIsRegistering(false);
      }
    } catch (err: any) {
      setErrorMessage('Registration failed.');
    }
  };

  return (
    <div className="login-box">
      <h2 className="text-xl mb-5 text-gray-800">{isRegistering ? 'Register' : 'Login'}</h2>
      <form onSubmit={isRegistering ? handleRegister : handleLogin}>
        <div className="textbox">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Inserisci la tua email"
            required
            onInvalid={(e) => {
              e.preventDefault()
              setErrorMessage('Inserisci un indirizzo email valido.');
            }}
          />
        </div>
        {isRegistering && (
          <>
            <div className="textbox">
              <label htmlFor="firstName">First Name:</label>
              <input
                type="text"
                id="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First name"
                required
              />
            </div>
            <div className="textbox">
              <label htmlFor="lastName">Last Name:</label>
              <input
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Last name"
                required
              />
            </div>
          </>
        )}

        <div className="textbox password-container">
          <label htmlFor="password">Password:</label>
          <input
            type={showPassword ? 'text' : 'password'}
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password..."
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="show-password-button"
          >
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              className="password-icon"
            />
          </button>
        </div>

        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <div className='login-box-footer'>
          {/* <div className='forgot-password' onClick={()=>navigate('/reset-password')}>
            Password dimenticata
          </div> */}
          
          <button type="submit" className="btn primary">{isRegistering ? 'Register' : 'Accedi'}</button>
        </div>
        
      </form>

      {/* <button
        onClick={() => {
          setErrorMessage('');
          setIsRegistering(!isRegistering);
        }}
        className="btn btn-switch"
      >
        {isRegistering ? 'Switch to Login' : 'Switch to Register'}
      </button> */}
    </div>
  );
};

export default Login;
